import React from 'react'
import { Navigate } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'
import { AdminPermission, AdminPermissionKey } from '../constants/adminPermissions'
import { resolveAdminPanelPath } from '../utils/permissionUtil'

export { AdminPermission }

export function guardRoute(permission: AdminPermissionKey, element: React.ReactElement) {
  return <ProtectedRoute permission={permission}>{element}</ProtectedRoute>
}

function ProtectedRoute({
  permission,
  children,
}: {
  permission: AdminPermissionKey
  children: React.ReactElement
}) {
  const { hasPermission } = usePermissions()
  if (!hasPermission(permission)) {
    return <Navigate to={resolveAdminPanelPath('/unauthorized')} replace />
  }
  return children
}
